module.exports = __webpack_public_path__ + "static/media/veengu-icons-sprite.96af5d54.svg";